import { ClientModel } from '@mercadoni/sinister/dist/lib/src/entities/clientModel'

const showByConfiguration = (clientConfig: ClientModel) => {
  if (typeof window === 'undefined') return false
  const w = window as Window & { getCookie?: (name: string) => string }
  const byCookie = w.getCookie?.('_IL-online-payments') === '1'
  const byConfiguration =
    typeof clientConfig?.onlinePayments === 'boolean'
      ? clientConfig?.onlinePayments
      : true
  return byConfiguration || byCookie
}

export const shouldEnableOPM = ({
  operationalModels,
  opsModel,
  clientConfig,
}: {
  operationalModels: string[]
  opsModel: string
  clientConfig: ClientModel
}) => {
  let enableOPM = false
  if (operationalModels.length > 0) {
    enableOPM = operationalModels.includes(opsModel)
  }
  return enableOPM && showByConfiguration(clientConfig)
}
